import { ChangeDetectionStrategy, Component } from "@angular/core";
import { AddClassModifierDirective } from "src/app/core/directives/add-class-modifier.directive";

@Component({
  selector: "app-page-loading-indicator",
  templateUrl: "./page-loading-indicator.component.html",
  styleUrl: "./page-loading-indicator.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AddClassModifierDirective],
})
export class PageLoadingIndicatorComponent {}
